import { Link } from "react-router-dom";

function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background text-neutral-200 gap-4">
      <h1 className="font-display text-6xl text-gold-500">404</h1>
      <p className="text-neutral-400">Página não encontrada.</p>
      <Link
        to="/"
        className="px-5 py-2.5 rounded-md bg-gold-500 text-background font-semibold hover:bg-gold-400 transition-colors"
      >
        Voltar para o início
      </Link>
    </div>
  );
}

export default NotFound;
